<template>
  <div>
    <top-bar heading="Users" :buttons="buttons"></top-bar>
    <div class="container-fluid p-3">
      <b-card header="Users">
        <vue-good-table
                :columns="filteredColumns"
                :rows="users.data"
                :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 10,
                  position: 'bottom',
                  perPageDropdown: [10, 25, 50, 100],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
                }"
                :isLoading="loading"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'actions'" class="text-primary">
                <router-link :to="'/users/' + props.row.id">
                  <font-awesome-icon icon="cog" style="width:30px;"></font-awesome-icon>
                </router-link>
                <router-link :to="'/users/' + props.row.id + '/results'" v-if="props.row.is_student">
                  <font-awesome-icon icon="poll" style="width:30px;"></font-awesome-icon>
                </router-link>
              <router-link :to="'/users/' + props.row.id + '/progression'" v-if="props.row.is_student">
               <font-awesome-icon icon="chart-pie" style="width:30px;"></font-awesome-icon>
              </router-link>
              <router-link :to="'/users/' + props.row.id + '/training_plan'" v-if="props.row.is_student && $auth.check(['admin', 'super_admin', 'super_admin', 'rto', 'rto_trainer'])">
                <font-awesome-icon icon="solar-panel" style="width:30px;"></font-awesome-icon>
              </router-link>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </b-card>
    </div>
  </div>
</template>
<script>
import TopBar from '../../components/TopBar';

export default {
  name: 'Users',
  components: {TopBar},
  data () {
    return {
      loading: false,
      users: {
        data: []
      },
      columns: [
        {
          label: 'First Name',
          field: 'name_first',
          sortable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          }
        },
        {
          label: 'Last Name',
          field: 'name_last',
          sortable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          }
        },
        {
          label: 'Store Name',
          field: 'employer.name_company',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          },
          is_student: true
        },
        {
          label: 'State',
          field: 'address_state_text',
          width: 80,
          sortable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          },
          is_student: true
        },
        {
          label: 'Supervisor',
          field: 'trainer.name_full',
          sortable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          },
          is_student: true
        },
        {
          label: 'RTO',
          field: 'rto.name',
          sortable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          }
        },
        {
          label: 'RTO Trainer',
          field: 'rto_trainer.name_full',
          sortable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Search...' // placeholder for filter input
          },
          is_student: true
        },
        {
          label: 'Actions',
          field: 'actions'
        }
      ],
      buttons: [
        {
          label: 'Add User',
          variant: 'teal',
          url: '/users/create'
        }
      ]
    };
  },
  methods: {
    getUsers () {
      this.loading = true;
      let queryParams = {
        includes: 'employer,trainer,rto,rto_trainer',
        role_id: this.$route.query.role_id,
        enabled: this.$route.query.enabled || 1
      };

      this.axios.get('/users', {params: queryParams}).then(rsp => {
        this.users = rsp.data;
        this.loading = false;
      });
    }
  },
  computed: {
    filteredColumns () {
      if ([6, 7, 8, 9, 10].includes(parseInt(this.$route.query.role_id))) {
        return this.columns;
      }
      return this.columns.filter(c => !c.is_student);
    }
  },
  watch: {
    '$route.query.role_id': function () {
      this.getUsers();
    }
  },
  mounted () {
    this.getUsers();
  },
  metaInfo: {
    title: 'Users'
  }
};
</script>
